import { Box, Paper, Stack } from "@mui/material";
import React from "react";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";

const Header = () => {
  return (
    <Box>
      <Paper>
        <Box>
          <Stack direction={"row"} spacing={2}>
            <GlobalSelectField
              options={{
                //   formik: formik,
                label: "Department",
                name: "department",
                data: [
                  { id: 1, name: "HR" },
                  { id: 2, name: "Tech" },
                ],
                keys: {
                  id: "id",
                  value: "name",
                },
                sx: {
                  width: "100%",
                },
              }}
            />
            <GlobalSelectField
              options={{
                //   formik: formik,
                label: "User Roles",
                name: "userRoles",
                data: [
                  { id: 1, name: "HR" },
                  { id: 2, name: "Tech" },
                ],
                keys: {
                  id: "id",
                  value: "name",
                },
                sx: {
                  width: "100%",
                },
              }}
            />
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default Header;
